/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as UserSetupRouteImport } from './routes/user-setup'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as RedirectingRouteImport } from './routes/redirecting'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as LoginRouteImport } from './routes/login'
import { Route as HealthRouteImport } from './routes/health'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as CapturedSmsRouteImport } from './routes/captured-sms'
import { Route as CapturedEmailsRouteImport } from './routes/captured-emails'
import { Route as BrokenRouteImport } from './routes/broken'
import { Route as AcceptProductInviteRouteImport } from './routes/accept-product-invite'
import { Route as AcceptInviteRouteImport } from './routes/accept-invite'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UsersIndexRouteImport } from './routes/users/index'
import { Route as ProductsIndexRouteImport } from './routes/products/index'
import { Route as OrganizationsIndexRouteImport } from './routes/organizations/index'
import { Route as WorkspaceProductModelsRouteImport } from './routes/workspace/product-models'
import { Route as UsersUserIdRouteImport } from './routes/users/$userId'
import { Route as SystemSmartApiRouteImport } from './routes/system/smart-api'
import { Route as SystemProductSimulationRouteImport } from './routes/system/product-simulation'
import { Route as SystemMockDataRouteImport } from './routes/system/mock-data'
import { Route as SystemE2eRouteImport } from './routes/system/e2e'
import { Route as SystemCaptureRouteImport } from './routes/system/capture'
import { Route as ProfileNotificationReportRouteImport } from './routes/profile_.notification-report'
import { Route as OrganizationsOrgIdRouteImport } from './routes/organizations/$orgId'
import { Route as WorkspaceUsersIndexRouteImport } from './routes/workspace/users/index'
import { Route as WorkspaceProductsIndexRouteImport } from './routes/workspace/products/index'
import { Route as WorkspaceOrganizationsIndexRouteImport } from './routes/workspace/organizations/index'
import { Route as WorkspaceAlertsIndexRouteImport } from './routes/workspace/alerts/index'
import { Route as UsersUserIdIndexRouteImport } from './routes/users/$userId.index'
import { Route as SystemSmartLinkIndexRouteImport } from './routes/system/smart-link/index'
import { Route as SystemRoadmapIndexRouteImport } from './routes/system/roadmap/index'
import { Route as SystemProductAnalyticsIndexRouteImport } from './routes/system/product-analytics/index'
import { Route as SystemLocalizationIndexRouteImport } from './routes/system/localization/index'
import { Route as SystemInsightsIndexRouteImport } from './routes/system/insights/index'
import { Route as SystemHistoryIndexRouteImport } from './routes/system/history/index'
import { Route as SystemFeaturesIndexRouteImport } from './routes/system/features/index'
import { Route as SystemEventsIndexRouteImport } from './routes/system/events/index'
import { Route as SystemDataCatalogIndexRouteImport } from './routes/system/data-catalog/index'
import { Route as SystemCommandHistoryIndexRouteImport } from './routes/system/command-history/index'
import { Route as SystemCommandCatalogIndexRouteImport } from './routes/system/command-catalog/index'
import { Route as SystemCertificationsIndexRouteImport } from './routes/system/certifications/index'
import { Route as SiteReportsIndexRouteImport } from './routes/site/reports/index'
import { Route as SiteOverviewIndexRouteImport } from './routes/site/overview/index'
import { Route as OrganizationsOrgIdIndexRouteImport } from './routes/organizations/$orgId.index'
import { Route as FleetSitesIndexRouteImport } from './routes/fleet/sites/index'
import { Route as FleetReportsIndexRouteImport } from './routes/fleet/reports/index'
import { Route as FleetProgramsIndexRouteImport } from './routes/fleet/programs/index'
import { Route as FleetAlertsIndexRouteImport } from './routes/fleet/alerts/index'
import { Route as AdministrationUsersIndexRouteImport } from './routes/administration/users/index'
import { Route as AdministrationProductsIndexRouteImport } from './routes/administration/products/index'
import { Route as AdministrationOrganizationsIndexRouteImport } from './routes/administration/organizations/index'
import { Route as WorkspaceUsersUserIdRouteImport } from './routes/workspace/users/$userId'
import { Route as WorkspaceProductsProductIdRouteImport } from './routes/workspace/products/$productId'
import { Route as WorkspaceOrganizationsOrgIdRouteImport } from './routes/workspace/organizations/$orgId'
import { Route as WorkspaceComponentsComponentIdRouteImport } from './routes/workspace/components/$componentId'
import { Route as UsersUserIdEditRouteImport } from './routes/users/$userId.edit'
import { Route as SystemLocalizationDefinitionsRouteImport } from './routes/system/localization/definitions'
import { Route as SystemLocalizationLanguageIdRouteImport } from './routes/system/localization/$languageId'
import { Route as SystemInsightsSupportRouteImport } from './routes/system/insights/support'
import { Route as SystemDataCatalogProductModelsRouteImport } from './routes/system/data-catalog/product-models'
import { Route as SystemDataCatalogCatalogIdRouteImport } from './routes/system/data-catalog/$catalogId'
import { Route as SystemCommandCatalogDefinitionIdRouteImport } from './routes/system/command-catalog/$definitionId'
import { Route as SystemCertificationsClaimsRouteImport } from './routes/system/certifications/claims'
import { Route as SystemCertificationsModuleIdRouteImport } from './routes/system/certifications/$moduleId'
import { Route as OrganizationsOrgIdEditRouteImport } from './routes/organizations/$orgId.edit'
import { Route as AuthGoogleCallbackRouteImport } from './routes/auth.google.callback'
import { Route as AdministrationUsersUserIdRouteImport } from './routes/administration/users/$userId'
import { Route as AdministrationOrganizationsOrgIdRouteImport } from './routes/administration/organizations/$orgId'
import { Route as WorkspaceUsersUserIdIndexRouteImport } from './routes/workspace/users/$userId.index'
import { Route as WorkspaceProductsProductIdIndexRouteImport } from './routes/workspace/products/$productId.index'
import { Route as WorkspaceOrganizationsOrgIdIndexRouteImport } from './routes/workspace/organizations/$orgId.index'
import { Route as WorkspaceComponentsComponentIdIndexRouteImport } from './routes/workspace/components/$componentId.index'
import { Route as SystemProductAnalyticsSessionsIndexRouteImport } from './routes/system/product-analytics/sessions/index'
import { Route as SystemProductAnalyticsErrorsIndexRouteImport } from './routes/system/product-analytics/errors/index'
import { Route as SystemLocalizationLanguageIdIndexRouteImport } from './routes/system/localization/$languageId.index'
import { Route as SystemInsightsGuidanceIndexRouteImport } from './routes/system/insights/guidance/index'
import { Route as SystemDataCatalogEnumGroupsIndexRouteImport } from './routes/system/data-catalog/enum-groups/index'
import { Route as SystemDataCatalogCatalogIdIndexRouteImport } from './routes/system/data-catalog/$catalogId.index'
import { Route as SystemCertificationsModuleIdIndexRouteImport } from './routes/system/certifications/$moduleId.index'
import { Route as AdministrationUsersUserIdIndexRouteImport } from './routes/administration/users/$userId.index'
import { Route as AdministrationOrganizationsOrgIdIndexRouteImport } from './routes/administration/organizations/$orgId.index'
import { Route as WorkspaceUsersUserIdNotificationReportRouteImport } from './routes/workspace/users/$userId.notification-report'
import { Route as WorkspaceUsersUserIdEditRouteImport } from './routes/workspace/users/$userId.edit'
import { Route as WorkspaceProductsProductIdSettingsRouteImport } from './routes/workspace/products/$productId.settings'
import { Route as WorkspaceProductsProductIdEditRouteImport } from './routes/workspace/products/$productId.edit'
import { Route as WorkspaceOrganizationsOrgIdEditRouteImport } from './routes/workspace/organizations/$orgId.edit'
import { Route as WorkspaceComponentsComponentIdEditRouteImport } from './routes/workspace/components/$componentId.edit'
import { Route as SystemProductAnalyticsSessionsSessionIdRouteImport } from './routes/system/product-analytics/sessions/$sessionId'
import { Route as SystemProductAnalyticsErrorsErrorIdRouteImport } from './routes/system/product-analytics/errors/$errorId'
import { Route as SystemInsightsGuidanceCatalogAlertIdRouteImport } from './routes/system/insights/guidance/$catalogAlertId'
import { Route as SystemDataCatalogEnumGroupsGroupIdRouteImport } from './routes/system/data-catalog/enum-groups/$groupId'
import { Route as AdministrationUsersUserIdEditRouteImport } from './routes/administration/users/$userId.edit'
import { Route as AdministrationOrganizationsOrgIdEditRouteImport } from './routes/administration/organizations/$orgId.edit'
import { Route as SystemProductAnalyticsSessionsSessionIdIndexRouteImport } from './routes/system/product-analytics/sessions/$sessionId.index'
import { Route as SystemProductAnalyticsErrorsErrorIdIndexRouteImport } from './routes/system/product-analytics/errors/$errorId.index'
import { Route as SystemDataCatalogEnumGroupsGroupIdIndexRouteImport } from './routes/system/data-catalog/enum-groups/$groupId.index'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const UserSetupRoute = UserSetupRouteImport.update({
  id: '/user-setup',
  path: '/user-setup',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const RedirectingRoute = RedirectingRouteImport.update({
  id: '/redirecting',
  path: '/redirecting',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const HealthRoute = HealthRouteImport.update({
  id: '/health',
  path: '/health',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const CapturedSmsRoute = CapturedSmsRouteImport.update({
  id: '/captured-sms',
  path: '/captured-sms',
  getParentRoute: () => rootRouteImport,
} as any)
const CapturedEmailsRoute = CapturedEmailsRouteImport.update({
  id: '/captured-emails',
  path: '/captured-emails',
  getParentRoute: () => rootRouteImport,
} as any)
const BrokenRoute = BrokenRouteImport.update({
  id: '/broken',
  path: '/broken',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptProductInviteRoute = AcceptProductInviteRouteImport.update({
  id: '/accept-product-invite',
  path: '/accept-product-invite',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInviteRoute = AcceptInviteRouteImport.update({
  id: '/accept-invite',
  path: '/accept-invite',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersIndexRoute = UsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsIndexRoute = ProductsIndexRouteImport.update({
  id: '/products/',
  path: '/products/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationsIndexRoute = OrganizationsIndexRouteImport.update({
  id: '/organizations/',
  path: '/organizations/',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspaceProductModelsRoute = WorkspaceProductModelsRouteImport.update({
  id: '/workspace/product-models',
  path: '/workspace/product-models',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersUserIdRoute = UsersUserIdRouteImport.update({
  id: '/users/$userId',
  path: '/users/$userId',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemSmartApiRoute = SystemSmartApiRouteImport.update({
  id: '/system/smart-api',
  path: '/system/smart-api',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemProductSimulationRoute = SystemProductSimulationRouteImport.update({
  id: '/system/product-simulation',
  path: '/system/product-simulation',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemMockDataRoute = SystemMockDataRouteImport.update({
  id: '/system/mock-data',
  path: '/system/mock-data',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemE2eRoute = SystemE2eRouteImport.update({
  id: '/system/e2e',
  path: '/system/e2e',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemCaptureRoute = SystemCaptureRouteImport.update({
  id: '/system/capture',
  path: '/system/capture',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileNotificationReportRoute =
  ProfileNotificationReportRouteImport.update({
    id: '/profile_/notification-report',
    path: '/profile/notification-report',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationsOrgIdRoute = OrganizationsOrgIdRouteImport.update({
  id: '/organizations/$orgId',
  path: '/organizations/$orgId',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspaceUsersIndexRoute = WorkspaceUsersIndexRouteImport.update({
  id: '/workspace/users/',
  path: '/workspace/users/',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspaceProductsIndexRoute = WorkspaceProductsIndexRouteImport.update({
  id: '/workspace/products/',
  path: '/workspace/products/',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspaceOrganizationsIndexRoute =
  WorkspaceOrganizationsIndexRouteImport.update({
    id: '/workspace/organizations/',
    path: '/workspace/organizations/',
    getParentRoute: () => rootRouteImport,
  } as any)
const WorkspaceAlertsIndexRoute = WorkspaceAlertsIndexRouteImport.update({
  id: '/workspace/alerts/',
  path: '/workspace/alerts/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersUserIdIndexRoute = UsersUserIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => UsersUserIdRoute,
} as any)
const SystemSmartLinkIndexRoute = SystemSmartLinkIndexRouteImport.update({
  id: '/system/smart-link/',
  path: '/system/smart-link/',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemRoadmapIndexRoute = SystemRoadmapIndexRouteImport.update({
  id: '/system/roadmap/',
  path: '/system/roadmap/',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemProductAnalyticsIndexRoute =
  SystemProductAnalyticsIndexRouteImport.update({
    id: '/system/product-analytics/',
    path: '/system/product-analytics/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SystemLocalizationIndexRoute = SystemLocalizationIndexRouteImport.update({
  id: '/system/localization/',
  path: '/system/localization/',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemInsightsIndexRoute = SystemInsightsIndexRouteImport.update({
  id: '/system/insights/',
  path: '/system/insights/',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemHistoryIndexRoute = SystemHistoryIndexRouteImport.update({
  id: '/system/history/',
  path: '/system/history/',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemFeaturesIndexRoute = SystemFeaturesIndexRouteImport.update({
  id: '/system/features/',
  path: '/system/features/',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemEventsIndexRoute = SystemEventsIndexRouteImport.update({
  id: '/system/events/',
  path: '/system/events/',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemDataCatalogIndexRoute = SystemDataCatalogIndexRouteImport.update({
  id: '/system/data-catalog/',
  path: '/system/data-catalog/',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemCommandHistoryIndexRoute =
  SystemCommandHistoryIndexRouteImport.update({
    id: '/system/command-history/',
    path: '/system/command-history/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SystemCommandCatalogIndexRoute =
  SystemCommandCatalogIndexRouteImport.update({
    id: '/system/command-catalog/',
    path: '/system/command-catalog/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SystemCertificationsIndexRoute =
  SystemCertificationsIndexRouteImport.update({
    id: '/system/certifications/',
    path: '/system/certifications/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SiteReportsIndexRoute = SiteReportsIndexRouteImport.update({
  id: '/site/reports/',
  path: '/site/reports/',
  getParentRoute: () => rootRouteImport,
} as any)
const SiteOverviewIndexRoute = SiteOverviewIndexRouteImport.update({
  id: '/site/overview/',
  path: '/site/overview/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationsOrgIdIndexRoute = OrganizationsOrgIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OrganizationsOrgIdRoute,
} as any)
const FleetSitesIndexRoute = FleetSitesIndexRouteImport.update({
  id: '/fleet/sites/',
  path: '/fleet/sites/',
  getParentRoute: () => rootRouteImport,
} as any)
const FleetReportsIndexRoute = FleetReportsIndexRouteImport.update({
  id: '/fleet/reports/',
  path: '/fleet/reports/',
  getParentRoute: () => rootRouteImport,
} as any)
const FleetProgramsIndexRoute = FleetProgramsIndexRouteImport.update({
  id: '/fleet/programs/',
  path: '/fleet/programs/',
  getParentRoute: () => rootRouteImport,
} as any)
const FleetAlertsIndexRoute = FleetAlertsIndexRouteImport.update({
  id: '/fleet/alerts/',
  path: '/fleet/alerts/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdministrationUsersIndexRoute =
  AdministrationUsersIndexRouteImport.update({
    id: '/administration/users/',
    path: '/administration/users/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdministrationProductsIndexRoute =
  AdministrationProductsIndexRouteImport.update({
    id: '/administration/products/',
    path: '/administration/products/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdministrationOrganizationsIndexRoute =
  AdministrationOrganizationsIndexRouteImport.update({
    id: '/administration/organizations/',
    path: '/administration/organizations/',
    getParentRoute: () => rootRouteImport,
  } as any)
const WorkspaceUsersUserIdRoute = WorkspaceUsersUserIdRouteImport.update({
  id: '/workspace/users/$userId',
  path: '/workspace/users/$userId',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspaceProductsProductIdRoute =
  WorkspaceProductsProductIdRouteImport.update({
    id: '/workspace/products/$productId',
    path: '/workspace/products/$productId',
    getParentRoute: () => rootRouteImport,
  } as any)
const WorkspaceOrganizationsOrgIdRoute =
  WorkspaceOrganizationsOrgIdRouteImport.update({
    id: '/workspace/organizations/$orgId',
    path: '/workspace/organizations/$orgId',
    getParentRoute: () => rootRouteImport,
  } as any)
const WorkspaceComponentsComponentIdRoute =
  WorkspaceComponentsComponentIdRouteImport.update({
    id: '/workspace/components/$componentId',
    path: '/workspace/components/$componentId',
    getParentRoute: () => rootRouteImport,
  } as any)
const UsersUserIdEditRoute = UsersUserIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => UsersUserIdRoute,
} as any)
const SystemLocalizationDefinitionsRoute =
  SystemLocalizationDefinitionsRouteImport.update({
    id: '/system/localization/definitions',
    path: '/system/localization/definitions',
    getParentRoute: () => rootRouteImport,
  } as any)
const SystemLocalizationLanguageIdRoute =
  SystemLocalizationLanguageIdRouteImport.update({
    id: '/system/localization/$languageId',
    path: '/system/localization/$languageId',
    getParentRoute: () => rootRouteImport,
  } as any)
const SystemInsightsSupportRoute = SystemInsightsSupportRouteImport.update({
  id: '/system/insights/support',
  path: '/system/insights/support',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemDataCatalogProductModelsRoute =
  SystemDataCatalogProductModelsRouteImport.update({
    id: '/system/data-catalog/product-models',
    path: '/system/data-catalog/product-models',
    getParentRoute: () => rootRouteImport,
  } as any)
const SystemDataCatalogCatalogIdRoute =
  SystemDataCatalogCatalogIdRouteImport.update({
    id: '/system/data-catalog/$catalogId',
    path: '/system/data-catalog/$catalogId',
    getParentRoute: () => rootRouteImport,
  } as any)
const SystemCommandCatalogDefinitionIdRoute =
  SystemCommandCatalogDefinitionIdRouteImport.update({
    id: '/system/command-catalog/$definitionId',
    path: '/system/command-catalog/$definitionId',
    getParentRoute: () => rootRouteImport,
  } as any)
const SystemCertificationsClaimsRoute =
  SystemCertificationsClaimsRouteImport.update({
    id: '/system/certifications/claims',
    path: '/system/certifications/claims',
    getParentRoute: () => rootRouteImport,
  } as any)
const SystemCertificationsModuleIdRoute =
  SystemCertificationsModuleIdRouteImport.update({
    id: '/system/certifications/$moduleId',
    path: '/system/certifications/$moduleId',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationsOrgIdEditRoute = OrganizationsOrgIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => OrganizationsOrgIdRoute,
} as any)
const AuthGoogleCallbackRoute = AuthGoogleCallbackRouteImport.update({
  id: '/auth/google/callback',
  path: '/auth/google/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AdministrationUsersUserIdRoute =
  AdministrationUsersUserIdRouteImport.update({
    id: '/administration/users/$userId',
    path: '/administration/users/$userId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdministrationOrganizationsOrgIdRoute =
  AdministrationOrganizationsOrgIdRouteImport.update({
    id: '/administration/organizations/$orgId',
    path: '/administration/organizations/$orgId',
    getParentRoute: () => rootRouteImport,
  } as any)
const WorkspaceUsersUserIdIndexRoute =
  WorkspaceUsersUserIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WorkspaceUsersUserIdRoute,
  } as any)
const WorkspaceProductsProductIdIndexRoute =
  WorkspaceProductsProductIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WorkspaceProductsProductIdRoute,
  } as any)
const WorkspaceOrganizationsOrgIdIndexRoute =
  WorkspaceOrganizationsOrgIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WorkspaceOrganizationsOrgIdRoute,
  } as any)
const WorkspaceComponentsComponentIdIndexRoute =
  WorkspaceComponentsComponentIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WorkspaceComponentsComponentIdRoute,
  } as any)
const SystemProductAnalyticsSessionsIndexRoute =
  SystemProductAnalyticsSessionsIndexRouteImport.update({
    id: '/system/product-analytics/sessions/',
    path: '/system/product-analytics/sessions/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SystemProductAnalyticsErrorsIndexRoute =
  SystemProductAnalyticsErrorsIndexRouteImport.update({
    id: '/system/product-analytics/errors/',
    path: '/system/product-analytics/errors/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SystemLocalizationLanguageIdIndexRoute =
  SystemLocalizationLanguageIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SystemLocalizationLanguageIdRoute,
  } as any)
const SystemInsightsGuidanceIndexRoute =
  SystemInsightsGuidanceIndexRouteImport.update({
    id: '/system/insights/guidance/',
    path: '/system/insights/guidance/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SystemDataCatalogEnumGroupsIndexRoute =
  SystemDataCatalogEnumGroupsIndexRouteImport.update({
    id: '/system/data-catalog/enum-groups/',
    path: '/system/data-catalog/enum-groups/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SystemDataCatalogCatalogIdIndexRoute =
  SystemDataCatalogCatalogIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SystemDataCatalogCatalogIdRoute,
  } as any)
const SystemCertificationsModuleIdIndexRoute =
  SystemCertificationsModuleIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SystemCertificationsModuleIdRoute,
  } as any)
const AdministrationUsersUserIdIndexRoute =
  AdministrationUsersUserIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdministrationUsersUserIdRoute,
  } as any)
const AdministrationOrganizationsOrgIdIndexRoute =
  AdministrationOrganizationsOrgIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdministrationOrganizationsOrgIdRoute,
  } as any)
const WorkspaceUsersUserIdNotificationReportRoute =
  WorkspaceUsersUserIdNotificationReportRouteImport.update({
    id: '/notification-report',
    path: '/notification-report',
    getParentRoute: () => WorkspaceUsersUserIdRoute,
  } as any)
const WorkspaceUsersUserIdEditRoute =
  WorkspaceUsersUserIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => WorkspaceUsersUserIdRoute,
  } as any)
const WorkspaceProductsProductIdSettingsRoute =
  WorkspaceProductsProductIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => WorkspaceProductsProductIdRoute,
  } as any)
const WorkspaceProductsProductIdEditRoute =
  WorkspaceProductsProductIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => WorkspaceProductsProductIdRoute,
  } as any)
const WorkspaceOrganizationsOrgIdEditRoute =
  WorkspaceOrganizationsOrgIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => WorkspaceOrganizationsOrgIdRoute,
  } as any)
const WorkspaceComponentsComponentIdEditRoute =
  WorkspaceComponentsComponentIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => WorkspaceComponentsComponentIdRoute,
  } as any)
const SystemProductAnalyticsSessionsSessionIdRoute =
  SystemProductAnalyticsSessionsSessionIdRouteImport.update({
    id: '/system/product-analytics/sessions/$sessionId',
    path: '/system/product-analytics/sessions/$sessionId',
    getParentRoute: () => rootRouteImport,
  } as any)
const SystemProductAnalyticsErrorsErrorIdRoute =
  SystemProductAnalyticsErrorsErrorIdRouteImport.update({
    id: '/system/product-analytics/errors/$errorId',
    path: '/system/product-analytics/errors/$errorId',
    getParentRoute: () => rootRouteImport,
  } as any)
const SystemInsightsGuidanceCatalogAlertIdRoute =
  SystemInsightsGuidanceCatalogAlertIdRouteImport.update({
    id: '/system/insights/guidance/$catalogAlertId',
    path: '/system/insights/guidance/$catalogAlertId',
    getParentRoute: () => rootRouteImport,
  } as any)
const SystemDataCatalogEnumGroupsGroupIdRoute =
  SystemDataCatalogEnumGroupsGroupIdRouteImport.update({
    id: '/system/data-catalog/enum-groups/$groupId',
    path: '/system/data-catalog/enum-groups/$groupId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdministrationUsersUserIdEditRoute =
  AdministrationUsersUserIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AdministrationUsersUserIdRoute,
  } as any)
const AdministrationOrganizationsOrgIdEditRoute =
  AdministrationOrganizationsOrgIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AdministrationOrganizationsOrgIdRoute,
  } as any)
const SystemProductAnalyticsSessionsSessionIdIndexRoute =
  SystemProductAnalyticsSessionsSessionIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SystemProductAnalyticsSessionsSessionIdRoute,
  } as any)
const SystemProductAnalyticsErrorsErrorIdIndexRoute =
  SystemProductAnalyticsErrorsErrorIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SystemProductAnalyticsErrorsErrorIdRoute,
  } as any)
const SystemDataCatalogEnumGroupsGroupIdIndexRoute =
  SystemDataCatalogEnumGroupsGroupIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SystemDataCatalogEnumGroupsGroupIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/accept-invite': typeof AcceptInviteRoute
  '/accept-product-invite': typeof AcceptProductInviteRoute
  '/broken': typeof BrokenRoute
  '/captured-emails': typeof CapturedEmailsRoute
  '/captured-sms': typeof CapturedSmsRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/health': typeof HealthRoute
  '/login': typeof LoginRoute
  '/profile': typeof ProfileRoute
  '/redirecting': typeof RedirectingRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/user-setup': typeof UserSetupRoute
  '/verify-email': typeof VerifyEmailRoute
  '/organizations/$orgId': typeof OrganizationsOrgIdRouteWithChildren
  '/profile/notification-report': typeof ProfileNotificationReportRoute
  '/system/capture': typeof SystemCaptureRoute
  '/system/e2e': typeof SystemE2eRoute
  '/system/mock-data': typeof SystemMockDataRoute
  '/system/product-simulation': typeof SystemProductSimulationRoute
  '/system/smart-api': typeof SystemSmartApiRoute
  '/users/$userId': typeof UsersUserIdRouteWithChildren
  '/workspace/product-models': typeof WorkspaceProductModelsRoute
  '/organizations': typeof OrganizationsIndexRoute
  '/products': typeof ProductsIndexRoute
  '/users': typeof UsersIndexRoute
  '/administration/organizations/$orgId': typeof AdministrationOrganizationsOrgIdRouteWithChildren
  '/administration/users/$userId': typeof AdministrationUsersUserIdRouteWithChildren
  '/auth/google/callback': typeof AuthGoogleCallbackRoute
  '/organizations/$orgId/edit': typeof OrganizationsOrgIdEditRoute
  '/system/certifications/$moduleId': typeof SystemCertificationsModuleIdRouteWithChildren
  '/system/certifications/claims': typeof SystemCertificationsClaimsRoute
  '/system/command-catalog/$definitionId': typeof SystemCommandCatalogDefinitionIdRoute
  '/system/data-catalog/$catalogId': typeof SystemDataCatalogCatalogIdRouteWithChildren
  '/system/data-catalog/product-models': typeof SystemDataCatalogProductModelsRoute
  '/system/insights/support': typeof SystemInsightsSupportRoute
  '/system/localization/$languageId': typeof SystemLocalizationLanguageIdRouteWithChildren
  '/system/localization/definitions': typeof SystemLocalizationDefinitionsRoute
  '/users/$userId/edit': typeof UsersUserIdEditRoute
  '/workspace/components/$componentId': typeof WorkspaceComponentsComponentIdRouteWithChildren
  '/workspace/organizations/$orgId': typeof WorkspaceOrganizationsOrgIdRouteWithChildren
  '/workspace/products/$productId': typeof WorkspaceProductsProductIdRouteWithChildren
  '/workspace/users/$userId': typeof WorkspaceUsersUserIdRouteWithChildren
  '/administration/organizations': typeof AdministrationOrganizationsIndexRoute
  '/administration/products': typeof AdministrationProductsIndexRoute
  '/administration/users': typeof AdministrationUsersIndexRoute
  '/fleet/alerts': typeof FleetAlertsIndexRoute
  '/fleet/programs': typeof FleetProgramsIndexRoute
  '/fleet/reports': typeof FleetReportsIndexRoute
  '/fleet/sites': typeof FleetSitesIndexRoute
  '/organizations/$orgId/': typeof OrganizationsOrgIdIndexRoute
  '/site/overview': typeof SiteOverviewIndexRoute
  '/site/reports': typeof SiteReportsIndexRoute
  '/system/certifications': typeof SystemCertificationsIndexRoute
  '/system/command-catalog': typeof SystemCommandCatalogIndexRoute
  '/system/command-history': typeof SystemCommandHistoryIndexRoute
  '/system/data-catalog': typeof SystemDataCatalogIndexRoute
  '/system/events': typeof SystemEventsIndexRoute
  '/system/features': typeof SystemFeaturesIndexRoute
  '/system/history': typeof SystemHistoryIndexRoute
  '/system/insights': typeof SystemInsightsIndexRoute
  '/system/localization': typeof SystemLocalizationIndexRoute
  '/system/product-analytics': typeof SystemProductAnalyticsIndexRoute
  '/system/roadmap': typeof SystemRoadmapIndexRoute
  '/system/smart-link': typeof SystemSmartLinkIndexRoute
  '/users/$userId/': typeof UsersUserIdIndexRoute
  '/workspace/alerts': typeof WorkspaceAlertsIndexRoute
  '/workspace/organizations': typeof WorkspaceOrganizationsIndexRoute
  '/workspace/products': typeof WorkspaceProductsIndexRoute
  '/workspace/users': typeof WorkspaceUsersIndexRoute
  '/administration/organizations/$orgId/edit': typeof AdministrationOrganizationsOrgIdEditRoute
  '/administration/users/$userId/edit': typeof AdministrationUsersUserIdEditRoute
  '/system/data-catalog/enum-groups/$groupId': typeof SystemDataCatalogEnumGroupsGroupIdRouteWithChildren
  '/system/insights/guidance/$catalogAlertId': typeof SystemInsightsGuidanceCatalogAlertIdRoute
  '/system/product-analytics/errors/$errorId': typeof SystemProductAnalyticsErrorsErrorIdRouteWithChildren
  '/system/product-analytics/sessions/$sessionId': typeof SystemProductAnalyticsSessionsSessionIdRouteWithChildren
  '/workspace/components/$componentId/edit': typeof WorkspaceComponentsComponentIdEditRoute
  '/workspace/organizations/$orgId/edit': typeof WorkspaceOrganizationsOrgIdEditRoute
  '/workspace/products/$productId/edit': typeof WorkspaceProductsProductIdEditRoute
  '/workspace/products/$productId/settings': typeof WorkspaceProductsProductIdSettingsRoute
  '/workspace/users/$userId/edit': typeof WorkspaceUsersUserIdEditRoute
  '/workspace/users/$userId/notification-report': typeof WorkspaceUsersUserIdNotificationReportRoute
  '/administration/organizations/$orgId/': typeof AdministrationOrganizationsOrgIdIndexRoute
  '/administration/users/$userId/': typeof AdministrationUsersUserIdIndexRoute
  '/system/certifications/$moduleId/': typeof SystemCertificationsModuleIdIndexRoute
  '/system/data-catalog/$catalogId/': typeof SystemDataCatalogCatalogIdIndexRoute
  '/system/data-catalog/enum-groups': typeof SystemDataCatalogEnumGroupsIndexRoute
  '/system/insights/guidance': typeof SystemInsightsGuidanceIndexRoute
  '/system/localization/$languageId/': typeof SystemLocalizationLanguageIdIndexRoute
  '/system/product-analytics/errors': typeof SystemProductAnalyticsErrorsIndexRoute
  '/system/product-analytics/sessions': typeof SystemProductAnalyticsSessionsIndexRoute
  '/workspace/components/$componentId/': typeof WorkspaceComponentsComponentIdIndexRoute
  '/workspace/organizations/$orgId/': typeof WorkspaceOrganizationsOrgIdIndexRoute
  '/workspace/products/$productId/': typeof WorkspaceProductsProductIdIndexRoute
  '/workspace/users/$userId/': typeof WorkspaceUsersUserIdIndexRoute
  '/system/data-catalog/enum-groups/$groupId/': typeof SystemDataCatalogEnumGroupsGroupIdIndexRoute
  '/system/product-analytics/errors/$errorId/': typeof SystemProductAnalyticsErrorsErrorIdIndexRoute
  '/system/product-analytics/sessions/$sessionId/': typeof SystemProductAnalyticsSessionsSessionIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/accept-invite': typeof AcceptInviteRoute
  '/accept-product-invite': typeof AcceptProductInviteRoute
  '/broken': typeof BrokenRoute
  '/captured-emails': typeof CapturedEmailsRoute
  '/captured-sms': typeof CapturedSmsRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/health': typeof HealthRoute
  '/login': typeof LoginRoute
  '/profile': typeof ProfileRoute
  '/redirecting': typeof RedirectingRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/user-setup': typeof UserSetupRoute
  '/verify-email': typeof VerifyEmailRoute
  '/profile/notification-report': typeof ProfileNotificationReportRoute
  '/system/capture': typeof SystemCaptureRoute
  '/system/e2e': typeof SystemE2eRoute
  '/system/mock-data': typeof SystemMockDataRoute
  '/system/product-simulation': typeof SystemProductSimulationRoute
  '/system/smart-api': typeof SystemSmartApiRoute
  '/workspace/product-models': typeof WorkspaceProductModelsRoute
  '/organizations': typeof OrganizationsIndexRoute
  '/products': typeof ProductsIndexRoute
  '/users': typeof UsersIndexRoute
  '/auth/google/callback': typeof AuthGoogleCallbackRoute
  '/organizations/$orgId/edit': typeof OrganizationsOrgIdEditRoute
  '/system/certifications/claims': typeof SystemCertificationsClaimsRoute
  '/system/command-catalog/$definitionId': typeof SystemCommandCatalogDefinitionIdRoute
  '/system/data-catalog/product-models': typeof SystemDataCatalogProductModelsRoute
  '/system/insights/support': typeof SystemInsightsSupportRoute
  '/system/localization/definitions': typeof SystemLocalizationDefinitionsRoute
  '/users/$userId/edit': typeof UsersUserIdEditRoute
  '/administration/organizations': typeof AdministrationOrganizationsIndexRoute
  '/administration/products': typeof AdministrationProductsIndexRoute
  '/administration/users': typeof AdministrationUsersIndexRoute
  '/fleet/alerts': typeof FleetAlertsIndexRoute
  '/fleet/programs': typeof FleetProgramsIndexRoute
  '/fleet/reports': typeof FleetReportsIndexRoute
  '/fleet/sites': typeof FleetSitesIndexRoute
  '/organizations/$orgId': typeof OrganizationsOrgIdIndexRoute
  '/site/overview': typeof SiteOverviewIndexRoute
  '/site/reports': typeof SiteReportsIndexRoute
  '/system/certifications': typeof SystemCertificationsIndexRoute
  '/system/command-catalog': typeof SystemCommandCatalogIndexRoute
  '/system/command-history': typeof SystemCommandHistoryIndexRoute
  '/system/data-catalog': typeof SystemDataCatalogIndexRoute
  '/system/events': typeof SystemEventsIndexRoute
  '/system/features': typeof SystemFeaturesIndexRoute
  '/system/history': typeof SystemHistoryIndexRoute
  '/system/insights': typeof SystemInsightsIndexRoute
  '/system/localization': typeof SystemLocalizationIndexRoute
  '/system/product-analytics': typeof SystemProductAnalyticsIndexRoute
  '/system/roadmap': typeof SystemRoadmapIndexRoute
  '/system/smart-link': typeof SystemSmartLinkIndexRoute
  '/users/$userId': typeof UsersUserIdIndexRoute
  '/workspace/alerts': typeof WorkspaceAlertsIndexRoute
  '/workspace/organizations': typeof WorkspaceOrganizationsIndexRoute
  '/workspace/products': typeof WorkspaceProductsIndexRoute
  '/workspace/users': typeof WorkspaceUsersIndexRoute
  '/administration/organizations/$orgId/edit': typeof AdministrationOrganizationsOrgIdEditRoute
  '/administration/users/$userId/edit': typeof AdministrationUsersUserIdEditRoute
  '/system/insights/guidance/$catalogAlertId': typeof SystemInsightsGuidanceCatalogAlertIdRoute
  '/workspace/components/$componentId/edit': typeof WorkspaceComponentsComponentIdEditRoute
  '/workspace/organizations/$orgId/edit': typeof WorkspaceOrganizationsOrgIdEditRoute
  '/workspace/products/$productId/edit': typeof WorkspaceProductsProductIdEditRoute
  '/workspace/products/$productId/settings': typeof WorkspaceProductsProductIdSettingsRoute
  '/workspace/users/$userId/edit': typeof WorkspaceUsersUserIdEditRoute
  '/workspace/users/$userId/notification-report': typeof WorkspaceUsersUserIdNotificationReportRoute
  '/administration/organizations/$orgId': typeof AdministrationOrganizationsOrgIdIndexRoute
  '/administration/users/$userId': typeof AdministrationUsersUserIdIndexRoute
  '/system/certifications/$moduleId': typeof SystemCertificationsModuleIdIndexRoute
  '/system/data-catalog/$catalogId': typeof SystemDataCatalogCatalogIdIndexRoute
  '/system/data-catalog/enum-groups': typeof SystemDataCatalogEnumGroupsIndexRoute
  '/system/insights/guidance': typeof SystemInsightsGuidanceIndexRoute
  '/system/localization/$languageId': typeof SystemLocalizationLanguageIdIndexRoute
  '/system/product-analytics/errors': typeof SystemProductAnalyticsErrorsIndexRoute
  '/system/product-analytics/sessions': typeof SystemProductAnalyticsSessionsIndexRoute
  '/workspace/components/$componentId': typeof WorkspaceComponentsComponentIdIndexRoute
  '/workspace/organizations/$orgId': typeof WorkspaceOrganizationsOrgIdIndexRoute
  '/workspace/products/$productId': typeof WorkspaceProductsProductIdIndexRoute
  '/workspace/users/$userId': typeof WorkspaceUsersUserIdIndexRoute
  '/system/data-catalog/enum-groups/$groupId': typeof SystemDataCatalogEnumGroupsGroupIdIndexRoute
  '/system/product-analytics/errors/$errorId': typeof SystemProductAnalyticsErrorsErrorIdIndexRoute
  '/system/product-analytics/sessions/$sessionId': typeof SystemProductAnalyticsSessionsSessionIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/accept-invite': typeof AcceptInviteRoute
  '/accept-product-invite': typeof AcceptProductInviteRoute
  '/broken': typeof BrokenRoute
  '/captured-emails': typeof CapturedEmailsRoute
  '/captured-sms': typeof CapturedSmsRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/health': typeof HealthRoute
  '/login': typeof LoginRoute
  '/profile': typeof ProfileRoute
  '/redirecting': typeof RedirectingRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/user-setup': typeof UserSetupRoute
  '/verify-email': typeof VerifyEmailRoute
  '/organizations/$orgId': typeof OrganizationsOrgIdRouteWithChildren
  '/profile_/notification-report': typeof ProfileNotificationReportRoute
  '/system/capture': typeof SystemCaptureRoute
  '/system/e2e': typeof SystemE2eRoute
  '/system/mock-data': typeof SystemMockDataRoute
  '/system/product-simulation': typeof SystemProductSimulationRoute
  '/system/smart-api': typeof SystemSmartApiRoute
  '/users/$userId': typeof UsersUserIdRouteWithChildren
  '/workspace/product-models': typeof WorkspaceProductModelsRoute
  '/organizations/': typeof OrganizationsIndexRoute
  '/products/': typeof ProductsIndexRoute
  '/users/': typeof UsersIndexRoute
  '/administration/organizations/$orgId': typeof AdministrationOrganizationsOrgIdRouteWithChildren
  '/administration/users/$userId': typeof AdministrationUsersUserIdRouteWithChildren
  '/auth/google/callback': typeof AuthGoogleCallbackRoute
  '/organizations/$orgId/edit': typeof OrganizationsOrgIdEditRoute
  '/system/certifications/$moduleId': typeof SystemCertificationsModuleIdRouteWithChildren
  '/system/certifications/claims': typeof SystemCertificationsClaimsRoute
  '/system/command-catalog/$definitionId': typeof SystemCommandCatalogDefinitionIdRoute
  '/system/data-catalog/$catalogId': typeof SystemDataCatalogCatalogIdRouteWithChildren
  '/system/data-catalog/product-models': typeof SystemDataCatalogProductModelsRoute
  '/system/insights/support': typeof SystemInsightsSupportRoute
  '/system/localization/$languageId': typeof SystemLocalizationLanguageIdRouteWithChildren
  '/system/localization/definitions': typeof SystemLocalizationDefinitionsRoute
  '/users/$userId/edit': typeof UsersUserIdEditRoute
  '/workspace/components/$componentId': typeof WorkspaceComponentsComponentIdRouteWithChildren
  '/workspace/organizations/$orgId': typeof WorkspaceOrganizationsOrgIdRouteWithChildren
  '/workspace/products/$productId': typeof WorkspaceProductsProductIdRouteWithChildren
  '/workspace/users/$userId': typeof WorkspaceUsersUserIdRouteWithChildren
  '/administration/organizations/': typeof AdministrationOrganizationsIndexRoute
  '/administration/products/': typeof AdministrationProductsIndexRoute
  '/administration/users/': typeof AdministrationUsersIndexRoute
  '/fleet/alerts/': typeof FleetAlertsIndexRoute
  '/fleet/programs/': typeof FleetProgramsIndexRoute
  '/fleet/reports/': typeof FleetReportsIndexRoute
  '/fleet/sites/': typeof FleetSitesIndexRoute
  '/organizations/$orgId/': typeof OrganizationsOrgIdIndexRoute
  '/site/overview/': typeof SiteOverviewIndexRoute
  '/site/reports/': typeof SiteReportsIndexRoute
  '/system/certifications/': typeof SystemCertificationsIndexRoute
  '/system/command-catalog/': typeof SystemCommandCatalogIndexRoute
  '/system/command-history/': typeof SystemCommandHistoryIndexRoute
  '/system/data-catalog/': typeof SystemDataCatalogIndexRoute
  '/system/events/': typeof SystemEventsIndexRoute
  '/system/features/': typeof SystemFeaturesIndexRoute
  '/system/history/': typeof SystemHistoryIndexRoute
  '/system/insights/': typeof SystemInsightsIndexRoute
  '/system/localization/': typeof SystemLocalizationIndexRoute
  '/system/product-analytics/': typeof SystemProductAnalyticsIndexRoute
  '/system/roadmap/': typeof SystemRoadmapIndexRoute
  '/system/smart-link/': typeof SystemSmartLinkIndexRoute
  '/users/$userId/': typeof UsersUserIdIndexRoute
  '/workspace/alerts/': typeof WorkspaceAlertsIndexRoute
  '/workspace/organizations/': typeof WorkspaceOrganizationsIndexRoute
  '/workspace/products/': typeof WorkspaceProductsIndexRoute
  '/workspace/users/': typeof WorkspaceUsersIndexRoute
  '/administration/organizations/$orgId/edit': typeof AdministrationOrganizationsOrgIdEditRoute
  '/administration/users/$userId/edit': typeof AdministrationUsersUserIdEditRoute
  '/system/data-catalog/enum-groups/$groupId': typeof SystemDataCatalogEnumGroupsGroupIdRouteWithChildren
  '/system/insights/guidance/$catalogAlertId': typeof SystemInsightsGuidanceCatalogAlertIdRoute
  '/system/product-analytics/errors/$errorId': typeof SystemProductAnalyticsErrorsErrorIdRouteWithChildren
  '/system/product-analytics/sessions/$sessionId': typeof SystemProductAnalyticsSessionsSessionIdRouteWithChildren
  '/workspace/components/$componentId/edit': typeof WorkspaceComponentsComponentIdEditRoute
  '/workspace/organizations/$orgId/edit': typeof WorkspaceOrganizationsOrgIdEditRoute
  '/workspace/products/$productId/edit': typeof WorkspaceProductsProductIdEditRoute
  '/workspace/products/$productId/settings': typeof WorkspaceProductsProductIdSettingsRoute
  '/workspace/users/$userId/edit': typeof WorkspaceUsersUserIdEditRoute
  '/workspace/users/$userId/notification-report': typeof WorkspaceUsersUserIdNotificationReportRoute
  '/administration/organizations/$orgId/': typeof AdministrationOrganizationsOrgIdIndexRoute
  '/administration/users/$userId/': typeof AdministrationUsersUserIdIndexRoute
  '/system/certifications/$moduleId/': typeof SystemCertificationsModuleIdIndexRoute
  '/system/data-catalog/$catalogId/': typeof SystemDataCatalogCatalogIdIndexRoute
  '/system/data-catalog/enum-groups/': typeof SystemDataCatalogEnumGroupsIndexRoute
  '/system/insights/guidance/': typeof SystemInsightsGuidanceIndexRoute
  '/system/localization/$languageId/': typeof SystemLocalizationLanguageIdIndexRoute
  '/system/product-analytics/errors/': typeof SystemProductAnalyticsErrorsIndexRoute
  '/system/product-analytics/sessions/': typeof SystemProductAnalyticsSessionsIndexRoute
  '/workspace/components/$componentId/': typeof WorkspaceComponentsComponentIdIndexRoute
  '/workspace/organizations/$orgId/': typeof WorkspaceOrganizationsOrgIdIndexRoute
  '/workspace/products/$productId/': typeof WorkspaceProductsProductIdIndexRoute
  '/workspace/users/$userId/': typeof WorkspaceUsersUserIdIndexRoute
  '/system/data-catalog/enum-groups/$groupId/': typeof SystemDataCatalogEnumGroupsGroupIdIndexRoute
  '/system/product-analytics/errors/$errorId/': typeof SystemProductAnalyticsErrorsErrorIdIndexRoute
  '/system/product-analytics/sessions/$sessionId/': typeof SystemProductAnalyticsSessionsSessionIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accept-invite'
    | '/accept-product-invite'
    | '/broken'
    | '/captured-emails'
    | '/captured-sms'
    | '/forgot-password'
    | '/health'
    | '/login'
    | '/profile'
    | '/redirecting'
    | '/register'
    | '/reset-password'
    | '/user-setup'
    | '/verify-email'
    | '/organizations/$orgId'
    | '/profile/notification-report'
    | '/system/capture'
    | '/system/e2e'
    | '/system/mock-data'
    | '/system/product-simulation'
    | '/system/smart-api'
    | '/users/$userId'
    | '/workspace/product-models'
    | '/organizations'
    | '/products'
    | '/users'
    | '/administration/organizations/$orgId'
    | '/administration/users/$userId'
    | '/auth/google/callback'
    | '/organizations/$orgId/edit'
    | '/system/certifications/$moduleId'
    | '/system/certifications/claims'
    | '/system/command-catalog/$definitionId'
    | '/system/data-catalog/$catalogId'
    | '/system/data-catalog/product-models'
    | '/system/insights/support'
    | '/system/localization/$languageId'
    | '/system/localization/definitions'
    | '/users/$userId/edit'
    | '/workspace/components/$componentId'
    | '/workspace/organizations/$orgId'
    | '/workspace/products/$productId'
    | '/workspace/users/$userId'
    | '/administration/organizations'
    | '/administration/products'
    | '/administration/users'
    | '/fleet/alerts'
    | '/fleet/programs'
    | '/fleet/reports'
    | '/fleet/sites'
    | '/organizations/$orgId/'
    | '/site/overview'
    | '/site/reports'
    | '/system/certifications'
    | '/system/command-catalog'
    | '/system/command-history'
    | '/system/data-catalog'
    | '/system/events'
    | '/system/features'
    | '/system/history'
    | '/system/insights'
    | '/system/localization'
    | '/system/product-analytics'
    | '/system/roadmap'
    | '/system/smart-link'
    | '/users/$userId/'
    | '/workspace/alerts'
    | '/workspace/organizations'
    | '/workspace/products'
    | '/workspace/users'
    | '/administration/organizations/$orgId/edit'
    | '/administration/users/$userId/edit'
    | '/system/data-catalog/enum-groups/$groupId'
    | '/system/insights/guidance/$catalogAlertId'
    | '/system/product-analytics/errors/$errorId'
    | '/system/product-analytics/sessions/$sessionId'
    | '/workspace/components/$componentId/edit'
    | '/workspace/organizations/$orgId/edit'
    | '/workspace/products/$productId/edit'
    | '/workspace/products/$productId/settings'
    | '/workspace/users/$userId/edit'
    | '/workspace/users/$userId/notification-report'
    | '/administration/organizations/$orgId/'
    | '/administration/users/$userId/'
    | '/system/certifications/$moduleId/'
    | '/system/data-catalog/$catalogId/'
    | '/system/data-catalog/enum-groups'
    | '/system/insights/guidance'
    | '/system/localization/$languageId/'
    | '/system/product-analytics/errors'
    | '/system/product-analytics/sessions'
    | '/workspace/components/$componentId/'
    | '/workspace/organizations/$orgId/'
    | '/workspace/products/$productId/'
    | '/workspace/users/$userId/'
    | '/system/data-catalog/enum-groups/$groupId/'
    | '/system/product-analytics/errors/$errorId/'
    | '/system/product-analytics/sessions/$sessionId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/accept-invite'
    | '/accept-product-invite'
    | '/broken'
    | '/captured-emails'
    | '/captured-sms'
    | '/forgot-password'
    | '/health'
    | '/login'
    | '/profile'
    | '/redirecting'
    | '/register'
    | '/reset-password'
    | '/user-setup'
    | '/verify-email'
    | '/profile/notification-report'
    | '/system/capture'
    | '/system/e2e'
    | '/system/mock-data'
    | '/system/product-simulation'
    | '/system/smart-api'
    | '/workspace/product-models'
    | '/organizations'
    | '/products'
    | '/users'
    | '/auth/google/callback'
    | '/organizations/$orgId/edit'
    | '/system/certifications/claims'
    | '/system/command-catalog/$definitionId'
    | '/system/data-catalog/product-models'
    | '/system/insights/support'
    | '/system/localization/definitions'
    | '/users/$userId/edit'
    | '/administration/organizations'
    | '/administration/products'
    | '/administration/users'
    | '/fleet/alerts'
    | '/fleet/programs'
    | '/fleet/reports'
    | '/fleet/sites'
    | '/organizations/$orgId'
    | '/site/overview'
    | '/site/reports'
    | '/system/certifications'
    | '/system/command-catalog'
    | '/system/command-history'
    | '/system/data-catalog'
    | '/system/events'
    | '/system/features'
    | '/system/history'
    | '/system/insights'
    | '/system/localization'
    | '/system/product-analytics'
    | '/system/roadmap'
    | '/system/smart-link'
    | '/users/$userId'
    | '/workspace/alerts'
    | '/workspace/organizations'
    | '/workspace/products'
    | '/workspace/users'
    | '/administration/organizations/$orgId/edit'
    | '/administration/users/$userId/edit'
    | '/system/insights/guidance/$catalogAlertId'
    | '/workspace/components/$componentId/edit'
    | '/workspace/organizations/$orgId/edit'
    | '/workspace/products/$productId/edit'
    | '/workspace/products/$productId/settings'
    | '/workspace/users/$userId/edit'
    | '/workspace/users/$userId/notification-report'
    | '/administration/organizations/$orgId'
    | '/administration/users/$userId'
    | '/system/certifications/$moduleId'
    | '/system/data-catalog/$catalogId'
    | '/system/data-catalog/enum-groups'
    | '/system/insights/guidance'
    | '/system/localization/$languageId'
    | '/system/product-analytics/errors'
    | '/system/product-analytics/sessions'
    | '/workspace/components/$componentId'
    | '/workspace/organizations/$orgId'
    | '/workspace/products/$productId'
    | '/workspace/users/$userId'
    | '/system/data-catalog/enum-groups/$groupId'
    | '/system/product-analytics/errors/$errorId'
    | '/system/product-analytics/sessions/$sessionId'
  id:
    | '__root__'
    | '/'
    | '/accept-invite'
    | '/accept-product-invite'
    | '/broken'
    | '/captured-emails'
    | '/captured-sms'
    | '/forgot-password'
    | '/health'
    | '/login'
    | '/profile'
    | '/redirecting'
    | '/register'
    | '/reset-password'
    | '/user-setup'
    | '/verify-email'
    | '/organizations/$orgId'
    | '/profile_/notification-report'
    | '/system/capture'
    | '/system/e2e'
    | '/system/mock-data'
    | '/system/product-simulation'
    | '/system/smart-api'
    | '/users/$userId'
    | '/workspace/product-models'
    | '/organizations/'
    | '/products/'
    | '/users/'
    | '/administration/organizations/$orgId'
    | '/administration/users/$userId'
    | '/auth/google/callback'
    | '/organizations/$orgId/edit'
    | '/system/certifications/$moduleId'
    | '/system/certifications/claims'
    | '/system/command-catalog/$definitionId'
    | '/system/data-catalog/$catalogId'
    | '/system/data-catalog/product-models'
    | '/system/insights/support'
    | '/system/localization/$languageId'
    | '/system/localization/definitions'
    | '/users/$userId/edit'
    | '/workspace/components/$componentId'
    | '/workspace/organizations/$orgId'
    | '/workspace/products/$productId'
    | '/workspace/users/$userId'
    | '/administration/organizations/'
    | '/administration/products/'
    | '/administration/users/'
    | '/fleet/alerts/'
    | '/fleet/programs/'
    | '/fleet/reports/'
    | '/fleet/sites/'
    | '/organizations/$orgId/'
    | '/site/overview/'
    | '/site/reports/'
    | '/system/certifications/'
    | '/system/command-catalog/'
    | '/system/command-history/'
    | '/system/data-catalog/'
    | '/system/events/'
    | '/system/features/'
    | '/system/history/'
    | '/system/insights/'
    | '/system/localization/'
    | '/system/product-analytics/'
    | '/system/roadmap/'
    | '/system/smart-link/'
    | '/users/$userId/'
    | '/workspace/alerts/'
    | '/workspace/organizations/'
    | '/workspace/products/'
    | '/workspace/users/'
    | '/administration/organizations/$orgId/edit'
    | '/administration/users/$userId/edit'
    | '/system/data-catalog/enum-groups/$groupId'
    | '/system/insights/guidance/$catalogAlertId'
    | '/system/product-analytics/errors/$errorId'
    | '/system/product-analytics/sessions/$sessionId'
    | '/workspace/components/$componentId/edit'
    | '/workspace/organizations/$orgId/edit'
    | '/workspace/products/$productId/edit'
    | '/workspace/products/$productId/settings'
    | '/workspace/users/$userId/edit'
    | '/workspace/users/$userId/notification-report'
    | '/administration/organizations/$orgId/'
    | '/administration/users/$userId/'
    | '/system/certifications/$moduleId/'
    | '/system/data-catalog/$catalogId/'
    | '/system/data-catalog/enum-groups/'
    | '/system/insights/guidance/'
    | '/system/localization/$languageId/'
    | '/system/product-analytics/errors/'
    | '/system/product-analytics/sessions/'
    | '/workspace/components/$componentId/'
    | '/workspace/organizations/$orgId/'
    | '/workspace/products/$productId/'
    | '/workspace/users/$userId/'
    | '/system/data-catalog/enum-groups/$groupId/'
    | '/system/product-analytics/errors/$errorId/'
    | '/system/product-analytics/sessions/$sessionId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AcceptInviteRoute: typeof AcceptInviteRoute
  AcceptProductInviteRoute: typeof AcceptProductInviteRoute
  BrokenRoute: typeof BrokenRoute
  CapturedEmailsRoute: typeof CapturedEmailsRoute
  CapturedSmsRoute: typeof CapturedSmsRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  HealthRoute: typeof HealthRoute
  LoginRoute: typeof LoginRoute
  ProfileRoute: typeof ProfileRoute
  RedirectingRoute: typeof RedirectingRoute
  RegisterRoute: typeof RegisterRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  UserSetupRoute: typeof UserSetupRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  OrganizationsOrgIdRoute: typeof OrganizationsOrgIdRouteWithChildren
  ProfileNotificationReportRoute: typeof ProfileNotificationReportRoute
  SystemCaptureRoute: typeof SystemCaptureRoute
  SystemE2eRoute: typeof SystemE2eRoute
  SystemMockDataRoute: typeof SystemMockDataRoute
  SystemProductSimulationRoute: typeof SystemProductSimulationRoute
  SystemSmartApiRoute: typeof SystemSmartApiRoute
  UsersUserIdRoute: typeof UsersUserIdRouteWithChildren
  WorkspaceProductModelsRoute: typeof WorkspaceProductModelsRoute
  OrganizationsIndexRoute: typeof OrganizationsIndexRoute
  ProductsIndexRoute: typeof ProductsIndexRoute
  UsersIndexRoute: typeof UsersIndexRoute
  AdministrationOrganizationsOrgIdRoute: typeof AdministrationOrganizationsOrgIdRouteWithChildren
  AdministrationUsersUserIdRoute: typeof AdministrationUsersUserIdRouteWithChildren
  AuthGoogleCallbackRoute: typeof AuthGoogleCallbackRoute
  SystemCertificationsModuleIdRoute: typeof SystemCertificationsModuleIdRouteWithChildren
  SystemCertificationsClaimsRoute: typeof SystemCertificationsClaimsRoute
  SystemCommandCatalogDefinitionIdRoute: typeof SystemCommandCatalogDefinitionIdRoute
  SystemDataCatalogCatalogIdRoute: typeof SystemDataCatalogCatalogIdRouteWithChildren
  SystemDataCatalogProductModelsRoute: typeof SystemDataCatalogProductModelsRoute
  SystemInsightsSupportRoute: typeof SystemInsightsSupportRoute
  SystemLocalizationLanguageIdRoute: typeof SystemLocalizationLanguageIdRouteWithChildren
  SystemLocalizationDefinitionsRoute: typeof SystemLocalizationDefinitionsRoute
  WorkspaceComponentsComponentIdRoute: typeof WorkspaceComponentsComponentIdRouteWithChildren
  WorkspaceOrganizationsOrgIdRoute: typeof WorkspaceOrganizationsOrgIdRouteWithChildren
  WorkspaceProductsProductIdRoute: typeof WorkspaceProductsProductIdRouteWithChildren
  WorkspaceUsersUserIdRoute: typeof WorkspaceUsersUserIdRouteWithChildren
  AdministrationOrganizationsIndexRoute: typeof AdministrationOrganizationsIndexRoute
  AdministrationProductsIndexRoute: typeof AdministrationProductsIndexRoute
  AdministrationUsersIndexRoute: typeof AdministrationUsersIndexRoute
  FleetAlertsIndexRoute: typeof FleetAlertsIndexRoute
  FleetProgramsIndexRoute: typeof FleetProgramsIndexRoute
  FleetReportsIndexRoute: typeof FleetReportsIndexRoute
  FleetSitesIndexRoute: typeof FleetSitesIndexRoute
  SiteOverviewIndexRoute: typeof SiteOverviewIndexRoute
  SiteReportsIndexRoute: typeof SiteReportsIndexRoute
  SystemCertificationsIndexRoute: typeof SystemCertificationsIndexRoute
  SystemCommandCatalogIndexRoute: typeof SystemCommandCatalogIndexRoute
  SystemCommandHistoryIndexRoute: typeof SystemCommandHistoryIndexRoute
  SystemDataCatalogIndexRoute: typeof SystemDataCatalogIndexRoute
  SystemEventsIndexRoute: typeof SystemEventsIndexRoute
  SystemFeaturesIndexRoute: typeof SystemFeaturesIndexRoute
  SystemHistoryIndexRoute: typeof SystemHistoryIndexRoute
  SystemInsightsIndexRoute: typeof SystemInsightsIndexRoute
  SystemLocalizationIndexRoute: typeof SystemLocalizationIndexRoute
  SystemProductAnalyticsIndexRoute: typeof SystemProductAnalyticsIndexRoute
  SystemRoadmapIndexRoute: typeof SystemRoadmapIndexRoute
  SystemSmartLinkIndexRoute: typeof SystemSmartLinkIndexRoute
  WorkspaceAlertsIndexRoute: typeof WorkspaceAlertsIndexRoute
  WorkspaceOrganizationsIndexRoute: typeof WorkspaceOrganizationsIndexRoute
  WorkspaceProductsIndexRoute: typeof WorkspaceProductsIndexRoute
  WorkspaceUsersIndexRoute: typeof WorkspaceUsersIndexRoute
  SystemDataCatalogEnumGroupsGroupIdRoute: typeof SystemDataCatalogEnumGroupsGroupIdRouteWithChildren
  SystemInsightsGuidanceCatalogAlertIdRoute: typeof SystemInsightsGuidanceCatalogAlertIdRoute
  SystemProductAnalyticsErrorsErrorIdRoute: typeof SystemProductAnalyticsErrorsErrorIdRouteWithChildren
  SystemProductAnalyticsSessionsSessionIdRoute: typeof SystemProductAnalyticsSessionsSessionIdRouteWithChildren
  SystemDataCatalogEnumGroupsIndexRoute: typeof SystemDataCatalogEnumGroupsIndexRoute
  SystemInsightsGuidanceIndexRoute: typeof SystemInsightsGuidanceIndexRoute
  SystemProductAnalyticsErrorsIndexRoute: typeof SystemProductAnalyticsErrorsIndexRoute
  SystemProductAnalyticsSessionsIndexRoute: typeof SystemProductAnalyticsSessionsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user-setup': {
      id: '/user-setup'
      path: '/user-setup'
      fullPath: '/user-setup'
      preLoaderRoute: typeof UserSetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/redirecting': {
      id: '/redirecting'
      path: '/redirecting'
      fullPath: '/redirecting'
      preLoaderRoute: typeof RedirectingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/health': {
      id: '/health'
      path: '/health'
      fullPath: '/health'
      preLoaderRoute: typeof HealthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/captured-sms': {
      id: '/captured-sms'
      path: '/captured-sms'
      fullPath: '/captured-sms'
      preLoaderRoute: typeof CapturedSmsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/captured-emails': {
      id: '/captured-emails'
      path: '/captured-emails'
      fullPath: '/captured-emails'
      preLoaderRoute: typeof CapturedEmailsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/broken': {
      id: '/broken'
      path: '/broken'
      fullPath: '/broken'
      preLoaderRoute: typeof BrokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-product-invite': {
      id: '/accept-product-invite'
      path: '/accept-product-invite'
      fullPath: '/accept-product-invite'
      preLoaderRoute: typeof AcceptProductInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invite': {
      id: '/accept-invite'
      path: '/accept-invite'
      fullPath: '/accept-invite'
      preLoaderRoute: typeof AcceptInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/': {
      id: '/users/'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/': {
      id: '/products/'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof ProductsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations/': {
      id: '/organizations/'
      path: '/organizations'
      fullPath: '/organizations'
      preLoaderRoute: typeof OrganizationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspace/product-models': {
      id: '/workspace/product-models'
      path: '/workspace/product-models'
      fullPath: '/workspace/product-models'
      preLoaderRoute: typeof WorkspaceProductModelsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/$userId': {
      id: '/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof UsersUserIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/smart-api': {
      id: '/system/smart-api'
      path: '/system/smart-api'
      fullPath: '/system/smart-api'
      preLoaderRoute: typeof SystemSmartApiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/product-simulation': {
      id: '/system/product-simulation'
      path: '/system/product-simulation'
      fullPath: '/system/product-simulation'
      preLoaderRoute: typeof SystemProductSimulationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/mock-data': {
      id: '/system/mock-data'
      path: '/system/mock-data'
      fullPath: '/system/mock-data'
      preLoaderRoute: typeof SystemMockDataRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/e2e': {
      id: '/system/e2e'
      path: '/system/e2e'
      fullPath: '/system/e2e'
      preLoaderRoute: typeof SystemE2eRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/capture': {
      id: '/system/capture'
      path: '/system/capture'
      fullPath: '/system/capture'
      preLoaderRoute: typeof SystemCaptureRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile_/notification-report': {
      id: '/profile_/notification-report'
      path: '/profile/notification-report'
      fullPath: '/profile/notification-report'
      preLoaderRoute: typeof ProfileNotificationReportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations/$orgId': {
      id: '/organizations/$orgId'
      path: '/organizations/$orgId'
      fullPath: '/organizations/$orgId'
      preLoaderRoute: typeof OrganizationsOrgIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspace/users/': {
      id: '/workspace/users/'
      path: '/workspace/users'
      fullPath: '/workspace/users'
      preLoaderRoute: typeof WorkspaceUsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspace/products/': {
      id: '/workspace/products/'
      path: '/workspace/products'
      fullPath: '/workspace/products'
      preLoaderRoute: typeof WorkspaceProductsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspace/organizations/': {
      id: '/workspace/organizations/'
      path: '/workspace/organizations'
      fullPath: '/workspace/organizations'
      preLoaderRoute: typeof WorkspaceOrganizationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspace/alerts/': {
      id: '/workspace/alerts/'
      path: '/workspace/alerts'
      fullPath: '/workspace/alerts'
      preLoaderRoute: typeof WorkspaceAlertsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/$userId/': {
      id: '/users/$userId/'
      path: '/'
      fullPath: '/users/$userId/'
      preLoaderRoute: typeof UsersUserIdIndexRouteImport
      parentRoute: typeof UsersUserIdRoute
    }
    '/system/smart-link/': {
      id: '/system/smart-link/'
      path: '/system/smart-link'
      fullPath: '/system/smart-link'
      preLoaderRoute: typeof SystemSmartLinkIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/roadmap/': {
      id: '/system/roadmap/'
      path: '/system/roadmap'
      fullPath: '/system/roadmap'
      preLoaderRoute: typeof SystemRoadmapIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/product-analytics/': {
      id: '/system/product-analytics/'
      path: '/system/product-analytics'
      fullPath: '/system/product-analytics'
      preLoaderRoute: typeof SystemProductAnalyticsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/localization/': {
      id: '/system/localization/'
      path: '/system/localization'
      fullPath: '/system/localization'
      preLoaderRoute: typeof SystemLocalizationIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/insights/': {
      id: '/system/insights/'
      path: '/system/insights'
      fullPath: '/system/insights'
      preLoaderRoute: typeof SystemInsightsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/history/': {
      id: '/system/history/'
      path: '/system/history'
      fullPath: '/system/history'
      preLoaderRoute: typeof SystemHistoryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/features/': {
      id: '/system/features/'
      path: '/system/features'
      fullPath: '/system/features'
      preLoaderRoute: typeof SystemFeaturesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/events/': {
      id: '/system/events/'
      path: '/system/events'
      fullPath: '/system/events'
      preLoaderRoute: typeof SystemEventsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/data-catalog/': {
      id: '/system/data-catalog/'
      path: '/system/data-catalog'
      fullPath: '/system/data-catalog'
      preLoaderRoute: typeof SystemDataCatalogIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/command-history/': {
      id: '/system/command-history/'
      path: '/system/command-history'
      fullPath: '/system/command-history'
      preLoaderRoute: typeof SystemCommandHistoryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/command-catalog/': {
      id: '/system/command-catalog/'
      path: '/system/command-catalog'
      fullPath: '/system/command-catalog'
      preLoaderRoute: typeof SystemCommandCatalogIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/certifications/': {
      id: '/system/certifications/'
      path: '/system/certifications'
      fullPath: '/system/certifications'
      preLoaderRoute: typeof SystemCertificationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/site/reports/': {
      id: '/site/reports/'
      path: '/site/reports'
      fullPath: '/site/reports'
      preLoaderRoute: typeof SiteReportsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/site/overview/': {
      id: '/site/overview/'
      path: '/site/overview'
      fullPath: '/site/overview'
      preLoaderRoute: typeof SiteOverviewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations/$orgId/': {
      id: '/organizations/$orgId/'
      path: '/'
      fullPath: '/organizations/$orgId/'
      preLoaderRoute: typeof OrganizationsOrgIdIndexRouteImport
      parentRoute: typeof OrganizationsOrgIdRoute
    }
    '/fleet/sites/': {
      id: '/fleet/sites/'
      path: '/fleet/sites'
      fullPath: '/fleet/sites'
      preLoaderRoute: typeof FleetSitesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fleet/reports/': {
      id: '/fleet/reports/'
      path: '/fleet/reports'
      fullPath: '/fleet/reports'
      preLoaderRoute: typeof FleetReportsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fleet/programs/': {
      id: '/fleet/programs/'
      path: '/fleet/programs'
      fullPath: '/fleet/programs'
      preLoaderRoute: typeof FleetProgramsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fleet/alerts/': {
      id: '/fleet/alerts/'
      path: '/fleet/alerts'
      fullPath: '/fleet/alerts'
      preLoaderRoute: typeof FleetAlertsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/users/': {
      id: '/administration/users/'
      path: '/administration/users'
      fullPath: '/administration/users'
      preLoaderRoute: typeof AdministrationUsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/products/': {
      id: '/administration/products/'
      path: '/administration/products'
      fullPath: '/administration/products'
      preLoaderRoute: typeof AdministrationProductsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/organizations/': {
      id: '/administration/organizations/'
      path: '/administration/organizations'
      fullPath: '/administration/organizations'
      preLoaderRoute: typeof AdministrationOrganizationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspace/users/$userId': {
      id: '/workspace/users/$userId'
      path: '/workspace/users/$userId'
      fullPath: '/workspace/users/$userId'
      preLoaderRoute: typeof WorkspaceUsersUserIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspace/products/$productId': {
      id: '/workspace/products/$productId'
      path: '/workspace/products/$productId'
      fullPath: '/workspace/products/$productId'
      preLoaderRoute: typeof WorkspaceProductsProductIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspace/organizations/$orgId': {
      id: '/workspace/organizations/$orgId'
      path: '/workspace/organizations/$orgId'
      fullPath: '/workspace/organizations/$orgId'
      preLoaderRoute: typeof WorkspaceOrganizationsOrgIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspace/components/$componentId': {
      id: '/workspace/components/$componentId'
      path: '/workspace/components/$componentId'
      fullPath: '/workspace/components/$componentId'
      preLoaderRoute: typeof WorkspaceComponentsComponentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/$userId/edit': {
      id: '/users/$userId/edit'
      path: '/edit'
      fullPath: '/users/$userId/edit'
      preLoaderRoute: typeof UsersUserIdEditRouteImport
      parentRoute: typeof UsersUserIdRoute
    }
    '/system/localization/definitions': {
      id: '/system/localization/definitions'
      path: '/system/localization/definitions'
      fullPath: '/system/localization/definitions'
      preLoaderRoute: typeof SystemLocalizationDefinitionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/localization/$languageId': {
      id: '/system/localization/$languageId'
      path: '/system/localization/$languageId'
      fullPath: '/system/localization/$languageId'
      preLoaderRoute: typeof SystemLocalizationLanguageIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/insights/support': {
      id: '/system/insights/support'
      path: '/system/insights/support'
      fullPath: '/system/insights/support'
      preLoaderRoute: typeof SystemInsightsSupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/data-catalog/product-models': {
      id: '/system/data-catalog/product-models'
      path: '/system/data-catalog/product-models'
      fullPath: '/system/data-catalog/product-models'
      preLoaderRoute: typeof SystemDataCatalogProductModelsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/data-catalog/$catalogId': {
      id: '/system/data-catalog/$catalogId'
      path: '/system/data-catalog/$catalogId'
      fullPath: '/system/data-catalog/$catalogId'
      preLoaderRoute: typeof SystemDataCatalogCatalogIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/command-catalog/$definitionId': {
      id: '/system/command-catalog/$definitionId'
      path: '/system/command-catalog/$definitionId'
      fullPath: '/system/command-catalog/$definitionId'
      preLoaderRoute: typeof SystemCommandCatalogDefinitionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/certifications/claims': {
      id: '/system/certifications/claims'
      path: '/system/certifications/claims'
      fullPath: '/system/certifications/claims'
      preLoaderRoute: typeof SystemCertificationsClaimsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/certifications/$moduleId': {
      id: '/system/certifications/$moduleId'
      path: '/system/certifications/$moduleId'
      fullPath: '/system/certifications/$moduleId'
      preLoaderRoute: typeof SystemCertificationsModuleIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations/$orgId/edit': {
      id: '/organizations/$orgId/edit'
      path: '/edit'
      fullPath: '/organizations/$orgId/edit'
      preLoaderRoute: typeof OrganizationsOrgIdEditRouteImport
      parentRoute: typeof OrganizationsOrgIdRoute
    }
    '/auth/google/callback': {
      id: '/auth/google/callback'
      path: '/auth/google/callback'
      fullPath: '/auth/google/callback'
      preLoaderRoute: typeof AuthGoogleCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/users/$userId': {
      id: '/administration/users/$userId'
      path: '/administration/users/$userId'
      fullPath: '/administration/users/$userId'
      preLoaderRoute: typeof AdministrationUsersUserIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/organizations/$orgId': {
      id: '/administration/organizations/$orgId'
      path: '/administration/organizations/$orgId'
      fullPath: '/administration/organizations/$orgId'
      preLoaderRoute: typeof AdministrationOrganizationsOrgIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspace/users/$userId/': {
      id: '/workspace/users/$userId/'
      path: '/'
      fullPath: '/workspace/users/$userId/'
      preLoaderRoute: typeof WorkspaceUsersUserIdIndexRouteImport
      parentRoute: typeof WorkspaceUsersUserIdRoute
    }
    '/workspace/products/$productId/': {
      id: '/workspace/products/$productId/'
      path: '/'
      fullPath: '/workspace/products/$productId/'
      preLoaderRoute: typeof WorkspaceProductsProductIdIndexRouteImport
      parentRoute: typeof WorkspaceProductsProductIdRoute
    }
    '/workspace/organizations/$orgId/': {
      id: '/workspace/organizations/$orgId/'
      path: '/'
      fullPath: '/workspace/organizations/$orgId/'
      preLoaderRoute: typeof WorkspaceOrganizationsOrgIdIndexRouteImport
      parentRoute: typeof WorkspaceOrganizationsOrgIdRoute
    }
    '/workspace/components/$componentId/': {
      id: '/workspace/components/$componentId/'
      path: '/'
      fullPath: '/workspace/components/$componentId/'
      preLoaderRoute: typeof WorkspaceComponentsComponentIdIndexRouteImport
      parentRoute: typeof WorkspaceComponentsComponentIdRoute
    }
    '/system/product-analytics/sessions/': {
      id: '/system/product-analytics/sessions/'
      path: '/system/product-analytics/sessions'
      fullPath: '/system/product-analytics/sessions'
      preLoaderRoute: typeof SystemProductAnalyticsSessionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/product-analytics/errors/': {
      id: '/system/product-analytics/errors/'
      path: '/system/product-analytics/errors'
      fullPath: '/system/product-analytics/errors'
      preLoaderRoute: typeof SystemProductAnalyticsErrorsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/localization/$languageId/': {
      id: '/system/localization/$languageId/'
      path: '/'
      fullPath: '/system/localization/$languageId/'
      preLoaderRoute: typeof SystemLocalizationLanguageIdIndexRouteImport
      parentRoute: typeof SystemLocalizationLanguageIdRoute
    }
    '/system/insights/guidance/': {
      id: '/system/insights/guidance/'
      path: '/system/insights/guidance'
      fullPath: '/system/insights/guidance'
      preLoaderRoute: typeof SystemInsightsGuidanceIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/data-catalog/enum-groups/': {
      id: '/system/data-catalog/enum-groups/'
      path: '/system/data-catalog/enum-groups'
      fullPath: '/system/data-catalog/enum-groups'
      preLoaderRoute: typeof SystemDataCatalogEnumGroupsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/data-catalog/$catalogId/': {
      id: '/system/data-catalog/$catalogId/'
      path: '/'
      fullPath: '/system/data-catalog/$catalogId/'
      preLoaderRoute: typeof SystemDataCatalogCatalogIdIndexRouteImport
      parentRoute: typeof SystemDataCatalogCatalogIdRoute
    }
    '/system/certifications/$moduleId/': {
      id: '/system/certifications/$moduleId/'
      path: '/'
      fullPath: '/system/certifications/$moduleId/'
      preLoaderRoute: typeof SystemCertificationsModuleIdIndexRouteImport
      parentRoute: typeof SystemCertificationsModuleIdRoute
    }
    '/administration/users/$userId/': {
      id: '/administration/users/$userId/'
      path: '/'
      fullPath: '/administration/users/$userId/'
      preLoaderRoute: typeof AdministrationUsersUserIdIndexRouteImport
      parentRoute: typeof AdministrationUsersUserIdRoute
    }
    '/administration/organizations/$orgId/': {
      id: '/administration/organizations/$orgId/'
      path: '/'
      fullPath: '/administration/organizations/$orgId/'
      preLoaderRoute: typeof AdministrationOrganizationsOrgIdIndexRouteImport
      parentRoute: typeof AdministrationOrganizationsOrgIdRoute
    }
    '/workspace/users/$userId/notification-report': {
      id: '/workspace/users/$userId/notification-report'
      path: '/notification-report'
      fullPath: '/workspace/users/$userId/notification-report'
      preLoaderRoute: typeof WorkspaceUsersUserIdNotificationReportRouteImport
      parentRoute: typeof WorkspaceUsersUserIdRoute
    }
    '/workspace/users/$userId/edit': {
      id: '/workspace/users/$userId/edit'
      path: '/edit'
      fullPath: '/workspace/users/$userId/edit'
      preLoaderRoute: typeof WorkspaceUsersUserIdEditRouteImport
      parentRoute: typeof WorkspaceUsersUserIdRoute
    }
    '/workspace/products/$productId/settings': {
      id: '/workspace/products/$productId/settings'
      path: '/settings'
      fullPath: '/workspace/products/$productId/settings'
      preLoaderRoute: typeof WorkspaceProductsProductIdSettingsRouteImport
      parentRoute: typeof WorkspaceProductsProductIdRoute
    }
    '/workspace/products/$productId/edit': {
      id: '/workspace/products/$productId/edit'
      path: '/edit'
      fullPath: '/workspace/products/$productId/edit'
      preLoaderRoute: typeof WorkspaceProductsProductIdEditRouteImport
      parentRoute: typeof WorkspaceProductsProductIdRoute
    }
    '/workspace/organizations/$orgId/edit': {
      id: '/workspace/organizations/$orgId/edit'
      path: '/edit'
      fullPath: '/workspace/organizations/$orgId/edit'
      preLoaderRoute: typeof WorkspaceOrganizationsOrgIdEditRouteImport
      parentRoute: typeof WorkspaceOrganizationsOrgIdRoute
    }
    '/workspace/components/$componentId/edit': {
      id: '/workspace/components/$componentId/edit'
      path: '/edit'
      fullPath: '/workspace/components/$componentId/edit'
      preLoaderRoute: typeof WorkspaceComponentsComponentIdEditRouteImport
      parentRoute: typeof WorkspaceComponentsComponentIdRoute
    }
    '/system/product-analytics/sessions/$sessionId': {
      id: '/system/product-analytics/sessions/$sessionId'
      path: '/system/product-analytics/sessions/$sessionId'
      fullPath: '/system/product-analytics/sessions/$sessionId'
      preLoaderRoute: typeof SystemProductAnalyticsSessionsSessionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/product-analytics/errors/$errorId': {
      id: '/system/product-analytics/errors/$errorId'
      path: '/system/product-analytics/errors/$errorId'
      fullPath: '/system/product-analytics/errors/$errorId'
      preLoaderRoute: typeof SystemProductAnalyticsErrorsErrorIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/insights/guidance/$catalogAlertId': {
      id: '/system/insights/guidance/$catalogAlertId'
      path: '/system/insights/guidance/$catalogAlertId'
      fullPath: '/system/insights/guidance/$catalogAlertId'
      preLoaderRoute: typeof SystemInsightsGuidanceCatalogAlertIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/data-catalog/enum-groups/$groupId': {
      id: '/system/data-catalog/enum-groups/$groupId'
      path: '/system/data-catalog/enum-groups/$groupId'
      fullPath: '/system/data-catalog/enum-groups/$groupId'
      preLoaderRoute: typeof SystemDataCatalogEnumGroupsGroupIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/users/$userId/edit': {
      id: '/administration/users/$userId/edit'
      path: '/edit'
      fullPath: '/administration/users/$userId/edit'
      preLoaderRoute: typeof AdministrationUsersUserIdEditRouteImport
      parentRoute: typeof AdministrationUsersUserIdRoute
    }
    '/administration/organizations/$orgId/edit': {
      id: '/administration/organizations/$orgId/edit'
      path: '/edit'
      fullPath: '/administration/organizations/$orgId/edit'
      preLoaderRoute: typeof AdministrationOrganizationsOrgIdEditRouteImport
      parentRoute: typeof AdministrationOrganizationsOrgIdRoute
    }
    '/system/product-analytics/sessions/$sessionId/': {
      id: '/system/product-analytics/sessions/$sessionId/'
      path: '/'
      fullPath: '/system/product-analytics/sessions/$sessionId/'
      preLoaderRoute: typeof SystemProductAnalyticsSessionsSessionIdIndexRouteImport
      parentRoute: typeof SystemProductAnalyticsSessionsSessionIdRoute
    }
    '/system/product-analytics/errors/$errorId/': {
      id: '/system/product-analytics/errors/$errorId/'
      path: '/'
      fullPath: '/system/product-analytics/errors/$errorId/'
      preLoaderRoute: typeof SystemProductAnalyticsErrorsErrorIdIndexRouteImport
      parentRoute: typeof SystemProductAnalyticsErrorsErrorIdRoute
    }
    '/system/data-catalog/enum-groups/$groupId/': {
      id: '/system/data-catalog/enum-groups/$groupId/'
      path: '/'
      fullPath: '/system/data-catalog/enum-groups/$groupId/'
      preLoaderRoute: typeof SystemDataCatalogEnumGroupsGroupIdIndexRouteImport
      parentRoute: typeof SystemDataCatalogEnumGroupsGroupIdRoute
    }
  }
}

interface OrganizationsOrgIdRouteChildren {
  OrganizationsOrgIdEditRoute: typeof OrganizationsOrgIdEditRoute
  OrganizationsOrgIdIndexRoute: typeof OrganizationsOrgIdIndexRoute
}

const OrganizationsOrgIdRouteChildren: OrganizationsOrgIdRouteChildren = {
  OrganizationsOrgIdEditRoute: OrganizationsOrgIdEditRoute,
  OrganizationsOrgIdIndexRoute: OrganizationsOrgIdIndexRoute,
}

const OrganizationsOrgIdRouteWithChildren =
  OrganizationsOrgIdRoute._addFileChildren(OrganizationsOrgIdRouteChildren)

interface UsersUserIdRouteChildren {
  UsersUserIdEditRoute: typeof UsersUserIdEditRoute
  UsersUserIdIndexRoute: typeof UsersUserIdIndexRoute
}

const UsersUserIdRouteChildren: UsersUserIdRouteChildren = {
  UsersUserIdEditRoute: UsersUserIdEditRoute,
  UsersUserIdIndexRoute: UsersUserIdIndexRoute,
}

const UsersUserIdRouteWithChildren = UsersUserIdRoute._addFileChildren(
  UsersUserIdRouteChildren,
)

interface AdministrationOrganizationsOrgIdRouteChildren {
  AdministrationOrganizationsOrgIdEditRoute: typeof AdministrationOrganizationsOrgIdEditRoute
  AdministrationOrganizationsOrgIdIndexRoute: typeof AdministrationOrganizationsOrgIdIndexRoute
}

const AdministrationOrganizationsOrgIdRouteChildren: AdministrationOrganizationsOrgIdRouteChildren =
  {
    AdministrationOrganizationsOrgIdEditRoute:
      AdministrationOrganizationsOrgIdEditRoute,
    AdministrationOrganizationsOrgIdIndexRoute:
      AdministrationOrganizationsOrgIdIndexRoute,
  }

const AdministrationOrganizationsOrgIdRouteWithChildren =
  AdministrationOrganizationsOrgIdRoute._addFileChildren(
    AdministrationOrganizationsOrgIdRouteChildren,
  )

interface AdministrationUsersUserIdRouteChildren {
  AdministrationUsersUserIdEditRoute: typeof AdministrationUsersUserIdEditRoute
  AdministrationUsersUserIdIndexRoute: typeof AdministrationUsersUserIdIndexRoute
}

const AdministrationUsersUserIdRouteChildren: AdministrationUsersUserIdRouteChildren =
  {
    AdministrationUsersUserIdEditRoute: AdministrationUsersUserIdEditRoute,
    AdministrationUsersUserIdIndexRoute: AdministrationUsersUserIdIndexRoute,
  }

const AdministrationUsersUserIdRouteWithChildren =
  AdministrationUsersUserIdRoute._addFileChildren(
    AdministrationUsersUserIdRouteChildren,
  )

interface SystemCertificationsModuleIdRouteChildren {
  SystemCertificationsModuleIdIndexRoute: typeof SystemCertificationsModuleIdIndexRoute
}

const SystemCertificationsModuleIdRouteChildren: SystemCertificationsModuleIdRouteChildren =
  {
    SystemCertificationsModuleIdIndexRoute:
      SystemCertificationsModuleIdIndexRoute,
  }

const SystemCertificationsModuleIdRouteWithChildren =
  SystemCertificationsModuleIdRoute._addFileChildren(
    SystemCertificationsModuleIdRouteChildren,
  )

interface SystemDataCatalogCatalogIdRouteChildren {
  SystemDataCatalogCatalogIdIndexRoute: typeof SystemDataCatalogCatalogIdIndexRoute
}

const SystemDataCatalogCatalogIdRouteChildren: SystemDataCatalogCatalogIdRouteChildren =
  {
    SystemDataCatalogCatalogIdIndexRoute: SystemDataCatalogCatalogIdIndexRoute,
  }

const SystemDataCatalogCatalogIdRouteWithChildren =
  SystemDataCatalogCatalogIdRoute._addFileChildren(
    SystemDataCatalogCatalogIdRouteChildren,
  )

interface SystemLocalizationLanguageIdRouteChildren {
  SystemLocalizationLanguageIdIndexRoute: typeof SystemLocalizationLanguageIdIndexRoute
}

const SystemLocalizationLanguageIdRouteChildren: SystemLocalizationLanguageIdRouteChildren =
  {
    SystemLocalizationLanguageIdIndexRoute:
      SystemLocalizationLanguageIdIndexRoute,
  }

const SystemLocalizationLanguageIdRouteWithChildren =
  SystemLocalizationLanguageIdRoute._addFileChildren(
    SystemLocalizationLanguageIdRouteChildren,
  )

interface WorkspaceComponentsComponentIdRouteChildren {
  WorkspaceComponentsComponentIdEditRoute: typeof WorkspaceComponentsComponentIdEditRoute
  WorkspaceComponentsComponentIdIndexRoute: typeof WorkspaceComponentsComponentIdIndexRoute
}

const WorkspaceComponentsComponentIdRouteChildren: WorkspaceComponentsComponentIdRouteChildren =
  {
    WorkspaceComponentsComponentIdEditRoute:
      WorkspaceComponentsComponentIdEditRoute,
    WorkspaceComponentsComponentIdIndexRoute:
      WorkspaceComponentsComponentIdIndexRoute,
  }

const WorkspaceComponentsComponentIdRouteWithChildren =
  WorkspaceComponentsComponentIdRoute._addFileChildren(
    WorkspaceComponentsComponentIdRouteChildren,
  )

interface WorkspaceOrganizationsOrgIdRouteChildren {
  WorkspaceOrganizationsOrgIdEditRoute: typeof WorkspaceOrganizationsOrgIdEditRoute
  WorkspaceOrganizationsOrgIdIndexRoute: typeof WorkspaceOrganizationsOrgIdIndexRoute
}

const WorkspaceOrganizationsOrgIdRouteChildren: WorkspaceOrganizationsOrgIdRouteChildren =
  {
    WorkspaceOrganizationsOrgIdEditRoute: WorkspaceOrganizationsOrgIdEditRoute,
    WorkspaceOrganizationsOrgIdIndexRoute:
      WorkspaceOrganizationsOrgIdIndexRoute,
  }

const WorkspaceOrganizationsOrgIdRouteWithChildren =
  WorkspaceOrganizationsOrgIdRoute._addFileChildren(
    WorkspaceOrganizationsOrgIdRouteChildren,
  )

interface WorkspaceProductsProductIdRouteChildren {
  WorkspaceProductsProductIdEditRoute: typeof WorkspaceProductsProductIdEditRoute
  WorkspaceProductsProductIdSettingsRoute: typeof WorkspaceProductsProductIdSettingsRoute
  WorkspaceProductsProductIdIndexRoute: typeof WorkspaceProductsProductIdIndexRoute
}

const WorkspaceProductsProductIdRouteChildren: WorkspaceProductsProductIdRouteChildren =
  {
    WorkspaceProductsProductIdEditRoute: WorkspaceProductsProductIdEditRoute,
    WorkspaceProductsProductIdSettingsRoute:
      WorkspaceProductsProductIdSettingsRoute,
    WorkspaceProductsProductIdIndexRoute: WorkspaceProductsProductIdIndexRoute,
  }

const WorkspaceProductsProductIdRouteWithChildren =
  WorkspaceProductsProductIdRoute._addFileChildren(
    WorkspaceProductsProductIdRouteChildren,
  )

interface WorkspaceUsersUserIdRouteChildren {
  WorkspaceUsersUserIdEditRoute: typeof WorkspaceUsersUserIdEditRoute
  WorkspaceUsersUserIdNotificationReportRoute: typeof WorkspaceUsersUserIdNotificationReportRoute
  WorkspaceUsersUserIdIndexRoute: typeof WorkspaceUsersUserIdIndexRoute
}

const WorkspaceUsersUserIdRouteChildren: WorkspaceUsersUserIdRouteChildren = {
  WorkspaceUsersUserIdEditRoute: WorkspaceUsersUserIdEditRoute,
  WorkspaceUsersUserIdNotificationReportRoute:
    WorkspaceUsersUserIdNotificationReportRoute,
  WorkspaceUsersUserIdIndexRoute: WorkspaceUsersUserIdIndexRoute,
}

const WorkspaceUsersUserIdRouteWithChildren =
  WorkspaceUsersUserIdRoute._addFileChildren(WorkspaceUsersUserIdRouteChildren)

interface SystemDataCatalogEnumGroupsGroupIdRouteChildren {
  SystemDataCatalogEnumGroupsGroupIdIndexRoute: typeof SystemDataCatalogEnumGroupsGroupIdIndexRoute
}

const SystemDataCatalogEnumGroupsGroupIdRouteChildren: SystemDataCatalogEnumGroupsGroupIdRouteChildren =
  {
    SystemDataCatalogEnumGroupsGroupIdIndexRoute:
      SystemDataCatalogEnumGroupsGroupIdIndexRoute,
  }

const SystemDataCatalogEnumGroupsGroupIdRouteWithChildren =
  SystemDataCatalogEnumGroupsGroupIdRoute._addFileChildren(
    SystemDataCatalogEnumGroupsGroupIdRouteChildren,
  )

interface SystemProductAnalyticsErrorsErrorIdRouteChildren {
  SystemProductAnalyticsErrorsErrorIdIndexRoute: typeof SystemProductAnalyticsErrorsErrorIdIndexRoute
}

const SystemProductAnalyticsErrorsErrorIdRouteChildren: SystemProductAnalyticsErrorsErrorIdRouteChildren =
  {
    SystemProductAnalyticsErrorsErrorIdIndexRoute:
      SystemProductAnalyticsErrorsErrorIdIndexRoute,
  }

const SystemProductAnalyticsErrorsErrorIdRouteWithChildren =
  SystemProductAnalyticsErrorsErrorIdRoute._addFileChildren(
    SystemProductAnalyticsErrorsErrorIdRouteChildren,
  )

interface SystemProductAnalyticsSessionsSessionIdRouteChildren {
  SystemProductAnalyticsSessionsSessionIdIndexRoute: typeof SystemProductAnalyticsSessionsSessionIdIndexRoute
}

const SystemProductAnalyticsSessionsSessionIdRouteChildren: SystemProductAnalyticsSessionsSessionIdRouteChildren =
  {
    SystemProductAnalyticsSessionsSessionIdIndexRoute:
      SystemProductAnalyticsSessionsSessionIdIndexRoute,
  }

const SystemProductAnalyticsSessionsSessionIdRouteWithChildren =
  SystemProductAnalyticsSessionsSessionIdRoute._addFileChildren(
    SystemProductAnalyticsSessionsSessionIdRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AcceptInviteRoute: AcceptInviteRoute,
  AcceptProductInviteRoute: AcceptProductInviteRoute,
  BrokenRoute: BrokenRoute,
  CapturedEmailsRoute: CapturedEmailsRoute,
  CapturedSmsRoute: CapturedSmsRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  HealthRoute: HealthRoute,
  LoginRoute: LoginRoute,
  ProfileRoute: ProfileRoute,
  RedirectingRoute: RedirectingRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  UserSetupRoute: UserSetupRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  OrganizationsOrgIdRoute: OrganizationsOrgIdRouteWithChildren,
  ProfileNotificationReportRoute: ProfileNotificationReportRoute,
  SystemCaptureRoute: SystemCaptureRoute,
  SystemE2eRoute: SystemE2eRoute,
  SystemMockDataRoute: SystemMockDataRoute,
  SystemProductSimulationRoute: SystemProductSimulationRoute,
  SystemSmartApiRoute: SystemSmartApiRoute,
  UsersUserIdRoute: UsersUserIdRouteWithChildren,
  WorkspaceProductModelsRoute: WorkspaceProductModelsRoute,
  OrganizationsIndexRoute: OrganizationsIndexRoute,
  ProductsIndexRoute: ProductsIndexRoute,
  UsersIndexRoute: UsersIndexRoute,
  AdministrationOrganizationsOrgIdRoute:
    AdministrationOrganizationsOrgIdRouteWithChildren,
  AdministrationUsersUserIdRoute: AdministrationUsersUserIdRouteWithChildren,
  AuthGoogleCallbackRoute: AuthGoogleCallbackRoute,
  SystemCertificationsModuleIdRoute:
    SystemCertificationsModuleIdRouteWithChildren,
  SystemCertificationsClaimsRoute: SystemCertificationsClaimsRoute,
  SystemCommandCatalogDefinitionIdRoute: SystemCommandCatalogDefinitionIdRoute,
  SystemDataCatalogCatalogIdRoute: SystemDataCatalogCatalogIdRouteWithChildren,
  SystemDataCatalogProductModelsRoute: SystemDataCatalogProductModelsRoute,
  SystemInsightsSupportRoute: SystemInsightsSupportRoute,
  SystemLocalizationLanguageIdRoute:
    SystemLocalizationLanguageIdRouteWithChildren,
  SystemLocalizationDefinitionsRoute: SystemLocalizationDefinitionsRoute,
  WorkspaceComponentsComponentIdRoute:
    WorkspaceComponentsComponentIdRouteWithChildren,
  WorkspaceOrganizationsOrgIdRoute:
    WorkspaceOrganizationsOrgIdRouteWithChildren,
  WorkspaceProductsProductIdRoute: WorkspaceProductsProductIdRouteWithChildren,
  WorkspaceUsersUserIdRoute: WorkspaceUsersUserIdRouteWithChildren,
  AdministrationOrganizationsIndexRoute: AdministrationOrganizationsIndexRoute,
  AdministrationProductsIndexRoute: AdministrationProductsIndexRoute,
  AdministrationUsersIndexRoute: AdministrationUsersIndexRoute,
  FleetAlertsIndexRoute: FleetAlertsIndexRoute,
  FleetProgramsIndexRoute: FleetProgramsIndexRoute,
  FleetReportsIndexRoute: FleetReportsIndexRoute,
  FleetSitesIndexRoute: FleetSitesIndexRoute,
  SiteOverviewIndexRoute: SiteOverviewIndexRoute,
  SiteReportsIndexRoute: SiteReportsIndexRoute,
  SystemCertificationsIndexRoute: SystemCertificationsIndexRoute,
  SystemCommandCatalogIndexRoute: SystemCommandCatalogIndexRoute,
  SystemCommandHistoryIndexRoute: SystemCommandHistoryIndexRoute,
  SystemDataCatalogIndexRoute: SystemDataCatalogIndexRoute,
  SystemEventsIndexRoute: SystemEventsIndexRoute,
  SystemFeaturesIndexRoute: SystemFeaturesIndexRoute,
  SystemHistoryIndexRoute: SystemHistoryIndexRoute,
  SystemInsightsIndexRoute: SystemInsightsIndexRoute,
  SystemLocalizationIndexRoute: SystemLocalizationIndexRoute,
  SystemProductAnalyticsIndexRoute: SystemProductAnalyticsIndexRoute,
  SystemRoadmapIndexRoute: SystemRoadmapIndexRoute,
  SystemSmartLinkIndexRoute: SystemSmartLinkIndexRoute,
  WorkspaceAlertsIndexRoute: WorkspaceAlertsIndexRoute,
  WorkspaceOrganizationsIndexRoute: WorkspaceOrganizationsIndexRoute,
  WorkspaceProductsIndexRoute: WorkspaceProductsIndexRoute,
  WorkspaceUsersIndexRoute: WorkspaceUsersIndexRoute,
  SystemDataCatalogEnumGroupsGroupIdRoute:
    SystemDataCatalogEnumGroupsGroupIdRouteWithChildren,
  SystemInsightsGuidanceCatalogAlertIdRoute:
    SystemInsightsGuidanceCatalogAlertIdRoute,
  SystemProductAnalyticsErrorsErrorIdRoute:
    SystemProductAnalyticsErrorsErrorIdRouteWithChildren,
  SystemProductAnalyticsSessionsSessionIdRoute:
    SystemProductAnalyticsSessionsSessionIdRouteWithChildren,
  SystemDataCatalogEnumGroupsIndexRoute: SystemDataCatalogEnumGroupsIndexRoute,
  SystemInsightsGuidanceIndexRoute: SystemInsightsGuidanceIndexRoute,
  SystemProductAnalyticsErrorsIndexRoute:
    SystemProductAnalyticsErrorsIndexRoute,
  SystemProductAnalyticsSessionsIndexRoute:
    SystemProductAnalyticsSessionsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
